import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class WebsiteDevelopment extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Website Development"
					title={"website development"}
					image={require('./image-3.jpg')}
				/>
				<div className="entry-content page-blog">


				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Website Development
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								
								<p>In this digital age, your website is your storefront and the digital face of your brand. Whether you’re offering ecommerce, multiple services, or you’d rather  just have an easy-to-digest one page site, everything your audience needs to know should be readily available.</p>

								<h4>The team at Moshi Moshi Marketing are the masters of website development in Perth and Bunbury.</h4>


								<p>We pride our web design services on being results driven - this means creating optimised, user friendly sites with the <b>solution</b> to your audience’s <b>problems</b> in the forefront of design, backed by detailed traffic data and reports. Our custom designs are unique to your business and your customer’s needs.</p>  <p>Our website development services are perfect for all business sizes, with a range of options available to suit most budgets - whatever your audience is requiring, we can deliver. As experts in Search Engine Optimisation (SEO), we will get your business an online presence that generates income and is something you can be proud of. We also provide extremely secure <a href="https://www.moshi.com.au/whatwedo/website-hosting">hosting services</a> to our clients to make sure your online investment stays safe and working the best it can every day of the year.
</p>
<a href="https://www.moshi.com.au/what-weve-done/churchview"><img src={require('./church.png')} style={{padding: 30}} height="375" width="350" alt="Churchview Estate" className="align-centre" align="centre" /></a>

<a href="https://www.moshi.com.au/what-weve-done/bunbury-central"><img src={require('./Bunbury-Central.png')} style={{padding: 30}} height="375" width="350" alt="Bunbury Central" className="align-centre" align="centre" /></a>
<a href="https://www.moshi.com.au/what-weve-done/hearth-house"><img src={require('./Hearth House.png')} style={{padding: 30}} height="375" width="350" alt="Hearth House Bunbury" className="align-centre" align="centre" /></a>
<a href="https://www.moshi.com.au/what-weve-done/harvey-senior-high-school"><img src={require('./hshs.png')} style={{padding: 30}} height="375" width="350" alt="Harvey Senior High School" className="align-centre" align="centre" /></a>
<a href="https://www.financialcounsellingnetwork.org.au/"><img src={require('./fcn.png')} style={{padding: 30}} height="375" width="350" alt="Financial Counselling Network" className="align-centre" align="centre" /></a>
<a href="https://www.moshi.com.au/what-weve-done/harley-dykstra"><img src={require('./Harley.png')} style={{padding: 30}} height="375" width="350" alt="Harley Dykstra" className="align-centre" align="centre" /></a>

<br></br>
<hr></hr>
<h2>Related Services</h2>

							<a class="btn" href="https://www.moshi.com.au/whatwedo/ecommerce-and-online-shops">Ecommerce and Online Shops</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-hosting">Website Hosting</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/domain-address-registration">Domain Address Registration</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-and-newsletter-content-writing">Website and Newsletter Content Writing</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-advertising">Google Advertising</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/graphic-design">Graphic Design</a>

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>

<hr></hr>
<br></br>
<h3> If you don’t have a website yet, or your existing site isn’t converting your online traffic, come in for a zero obligation chat.</h3>
					</div>
				</div>

			</div>
		);
	}
}

export default WebsiteDevelopment;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/WebsiteDevelopment.js